import { shadows as shadowDefinitions } from 'theme/tokens';

const muiShadows = [
  'none',
  shadowDefinitions.xxSmall,
  shadowDefinitions.xSmall,
  shadowDefinitions.small,
  shadowDefinitions.medium,
  shadowDefinitions.medium,
  shadowDefinitions.large,
  shadowDefinitions.large,
  shadowDefinitions.xLarge,
  shadowDefinitions.xLarge,
  shadowDefinitions.xxLarge,
  shadowDefinitions.xxLarge,
  shadowDefinitions.xxLarge,
  ...Array(12).fill(shadowDefinitions.xxLarge),
];

export { shadowDefinitions };
export default muiShadows;
